import { absoluteUrl } from './pageSeo';
import { productDetailImageUrl } from './cloudinaryImage';

/** Absolute HTTPS image URL for social / WhatsApp link previews. */
export function shareProductImageUrl(product) {
  if (!product) return '';
  const raw =
    product.thumbnail ||
    product.image ||
    (Array.isArray(product.images) && product.images[0]) ||
    '';
  const src = String(raw || '').trim();
  if (!src) return absoluteUrl('/images/products/electronics.jpg');
  const optimized = productDetailImageUrl(src);
  return absoluteUrl(optimized);
}
